import { useContext, useEffect, useRef, useState } from 'react';

import { BottomIcon, Button, TopIcon } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { openConfirmDialog } from 'services/Confirmation';
import { ESyncScope } from 'types';

import s from '../ApplicationManager.module.scss';

interface RemoveButtonProps {
  onDelete: (scope: ESyncScope) => void;
}

export const RemoveButton: React.FC<RemoveButtonProps> = ({ onDelete }) => {
  const { t } = useContext(LocalizationContext);
  const dropdownDeleteRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        isOpenDelete &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpenDelete(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenDelete]);

  return (
    <div ref={wrapperRef} className={s.button_block}>
      <Button
        variant="outline"
        color="red"
        onClick={() => setIsOpenDelete(!isOpenDelete)}
        fullWidth
        className={s.button}
      >
        {t('delete')}
      </Button>
      <div className={s.arrow} onClick={() => setIsOpenDelete(!isOpenDelete)}>
        {isOpenDelete ? (
          <TopIcon size="l" color="error" />
        ) : (
          <BottomIcon size="l" color="error" />
        )}
      </div>
      {isOpenDelete && (
        <div ref={dropdownDeleteRef} className={s.dropdown}>
          <div
            className={s.drop_item}
            onClick={() =>
              openConfirmDialog(t, 'remove', {
                title: t('modal.delete.club.network.title_2'),
                message: t('modal.delete.club.network.description_2'),
                acceptTitle: t('delete'),
                declineTitle: t('cancel_2'),
              }).then(({ status }) => {
                if (status === 'ACCEPTED') {
                  onDelete(ESyncScope.LOCAL);
                  setIsOpenDelete(false);
                }
              })
            }
          >
            {t('application.manager.button_1')}
          </div>
          <div
            className={s.drop_item}
            onClick={() =>
              openConfirmDialog(t, 'remove', {
                title: t('modal.delete.club.network.title_1'),
                message: t('modal.delete.club.network.description_1'),
                acceptTitle: t('delete'),
                declineTitle: t('cancel_2'),
              }).then(({ status }) => {
                if (status === 'ACCEPTED') {
                  onDelete(ESyncScope.NETWORK);
                  setIsOpenDelete(false);
                }
              })
            }
          >
            {t('application.manager.button_2')}
          </div>
        </div>
      )}
    </div>
  );
};
